import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { uploadFile } from '../../services/files.service';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
}));

export const UploadCartaComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const [uploading, setUploading] = React.useState(false);

  const manageFile = async (event) => {
    setUploading(true);
    const files = event?.target.files;
    const [fileToUpload] = files;
    const file = await uploadFile('carta.pdf', fileToUpload);
    setUploading(false);
    if(Boolean(file)) {
      history.push('/carta');
    }
  }

  return (
    <div>
      <input
        accept="application/pdf"
        className={classes.input}
        id="contained-button-file"
        multiple
        type="file"
        onChange={manageFile}
      />
      <label htmlFor="contained-button-file">
        <Button 
          variant="contained" 
          color="primary" 
          component="span"
          disabled={uploading}
        >
          Subir Carta
        </Button>
      </label>
      {uploading && (
        <div>
          <CircularProgress />
          <span>Subiendo...</span>
        </div>
      )}
    </div>
  )
}